var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.roles && (_vm.user.roles.includes('*') || _vm.userHasResourceAccess(_vm.RESOURCENAMES.MANAGEMENT)))?_c('div',[_c('AuditLogList')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }